import AccomplishmentCard from "views/Builder/components/accomplishments/cards";

import badgeImage from "../assets/devops-guild-badge.png";
import backgroundImage from "../assets/devops-guild-background.png";

export const DevOpsGuildCard = () => (
  <AccomplishmentCard
    badgeImage={badgeImage}
    backgroundImage={backgroundImage}
    title="DevOps guild member"
    description="A systems thinker enabling resilient infrastructure and seamless delivery."
  />
);
